import { o_global } from "@gr-common/head/namespaces";
const grScope = o_global.debug.scope("gr");
export {
  grScope
};
